/**
 * Màn hình danh sách người dùng
 */
import { memo } from "react";
import { Layout, Typography, Space } from "antd";
import ListContract from "pages/Contract/ListContract/index";
const { Title } = Typography;
const { Content } = Layout;
function Contract() {
  return (
    <Content
      className="custom-layout-content background-content-layout"
      style={{
        marginLeft: 24,
        marginTop: 16,
        marginRight: 24,
        backgroundColor: "white",
      }}
    >
      <Space
        direction="vertical"
        style={{
          width: "100%",
        }}
        size={"large"}
      >
        <div className="space-between ">
          <Title style={{ marginBottom: 0 }} level={4}>
            Danh sách hợp đồng khách hàng
          </Title>
        </div>
        <ListContract />
      </Space>
    </Content>
  );
}

export default memo(Contract);
